import { stringify } from "querystringify"

import { Analytics } from "utils/analytics"
import { getTildaUtm } from "utils/utm"
import { UserAccount } from "utils/UserAccount"
import { httpClient } from "utils/infrastructure/httpClient"

export function sendManualSelectionRequest({
    message,
    name,
    email,
}: {
    message: string
    name?: string
    email?: string
}) {
    const urlParams = {
        contact_type: "email",
        contact: email || UserAccount.email,
        name: name || UserAccount.name,
        client_description: message,
        utm: getTildaUtm(),
    }
    return httpClient.post(`manual_selection?${stringify(urlParams)}`).then(() => {
        Analytics.send_manual_selection_request({ name: name, email: email })
    })
}
